import moment from 'moment';

moment.updateLocale('en', {
  relativeTime: {
    s: 's',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1m',
    MM: '%dm',
    y: '1y',
    yy: '%dy',
  },
});

moment.updateLocale('de', {
  relativeTime: {
    s: 'vor ein paar Sekunden',
    ss: 'vor %d Sekunden',
    m: 'vor einer Minute',
    mm: 'vor %d Minuten',
    h: 'vor einer Stunde',
    hh: 'vor %d Stunden',
    d: 'vor einem Tag',
    dd: 'vor %d Tagen',
    M: 'vor einem Monat',
    MM: 'vor %d Monaten',
    y: 'vor einem Jahr',
    yy: 'vor %d Jahren',
  },
});
